import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";

function getColor(value) {
  if (value == null) return "bg-gray-300 text-gray-700";
  if (value > 5) return "bg-red-500 text-white";
  if (value > 2) return "bg-yellow-400 text-black";
  return "bg-green-500 text-white";
}

export default function UnbalancesPage() {
  const { t } = useTranslation();
  const { deviceId } = useParams();
  const [data, setData] = useState({});
  const API_BASE = process.env.REACT_APP_API_BASE_URL;

  useEffect(() => {
    async function fetchData() {
      try {
        const res = await fetch(
          `${API_BASE}/measurements/unbalances?deviceId=${deviceId}`
        );
        const json = await res.json();
        setData(json);
      } catch (err) {
        console.error("fetch unbalances error:", err);
      }
    }
    fetchData();
    const i = setInterval(fetchData, 5000);
    return () => clearInterval(i);
  }, [deviceId, API_BASE]);

  return (
    <div className="p-6 grid grid-cols-1 md:grid-cols-2 gap-6">
      <Card title={t('unbalances.voltageUnbalance')} value={data.VoltUnbalance} />
      <Card title={t('unbalances.currentUnbalance')} value={data.CurrUnbalance} />
    </div>
  );
}

function Card({ title, value }) {
  return (
    <div
      className={`rounded-2xl shadow-md p-6 flex flex-col items-center justify-center ${getColor(
        value
      )}`}
    >
      <h3 className="text-sm font-medium">{title}</h3>
      <p className="text-2xl font-bold">
        {value != null ? value.toFixed(2) : "-"} %
      </p>
    </div>
  );
}
